import { Button, Col, Row, Space, Spin, Tooltip, Upload } from "antd";
import { receiveService } from "api";
import axiosClient from "api/axiosClient";
import Icons from "assets/icons";
import React, { useRef, useState } from "react";
import { Page, Document } from "react-pdf";
import ReactToPrint from "react-to-print";
import NewSignSecure from "../../../../../SignSecure/components/NewSignSecure";
import { ModalCustom, Notification } from "components/common";
import ContentSignSecure from "pages/SignSecure/components/ContentSignSecure";
import { FORMAT_TIME } from "types/enums";
import {
  convertDateStringToDateTimezone_7Dayjs,
  renderGender,
} from "helper/common";
import "./style.scss";
import { UploadOutlined } from "@ant-design/icons";

const SignedSecure = (props) => {
  const { dataPatient, fileImg, closeModal } = props;
  const [numPages, setNumPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [file, setFilePdf] = useState<File | string | object>({});
  const modalViewer = useRef<any>();
  const printRef = useRef<any>();
  const NewPrintRef = useRef();
  const onLoadPageDocument = (pdf: { numPages: number }) => {
    setNumPages(pdf.numPages);
  };
  const onShowModalSignSecure = async () => {
    setLoading(true);
    try {
      await receiveService.requireSignSecure(dataPatient.id);
      Notification(
        "success",
        "Yêu cầu kí bảo mật thành công! Vui lòng chờ trong giây lát."
      );
      setLoading(false);
    } catch (error) {
      console.log("🚀 ~ onShowModalSignSecure ~ error:", error);
    }
    setLoading(false);
    // Notification("error", "Yêu cầu kí bảo mật không thành công");
    // signSecureRef.current?.setData(form.getFieldsValue());
    // signSecureRef.current?.openModal();
  };
  const handleOnView = async () => {
    setLoading(true);
    try {
      // const res = await receiveService.getPDFByPatient(thongTinBN?.maBenhNhan);
      const url = `/qlkhambenh/phieu-kham/dang-ky-bao-mat/pdf?id_benh_nhan=${dataPatient.idBenhNhan}`;
      const res = await axiosClient.get(url, { responseType: "blob" });
      const data = res.data;
      setFilePdf(data);
      setLoading(false);
      modalViewer.current?.openModal();
    } catch (error) {
      console.log("🚀 ~ handleOnView ~ error:", error);
      setLoading(false);
      Notification("error", "Bệnh nhân chưa có biên bản đã kí");
    }
  };

  const onPrint = () => {
    window.print();
  };

  const customRequest = async (options: any) => {
    // Gửi yêu cầu POST tới máy chủ
    setLoading(true);
    const file_size = options.file.size;
    try {
      // Tạo một FormData để gửi tệp lên máy chủ
      const formData = new FormData();
      formData.append("pdfFile", options.file as Blob);

      await receiveService.uploadFileResultSignSecure(
        dataPatient?.maBenhNhan,
        formData
      );
      Notification("success", "Đã tải file thành công");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        "Lỗi khi tải file hoặc kích cỡ file đạt quá giới hạn"
      );
    }
    return false;
  };

  //   useMemo(()=>{
  // if (condition) {

  // }
  //   },[dataPatient])
  console.log(
    convertDateStringToDateTimezone_7Dayjs(
      dataPatient.ngaySinh,
      FORMAT_TIME.dayFull
    )
  );

  return (
    <Spin spinning={loading} className="modal-custom">
      <Space direction="vertical" style={{ width: "100%" }}>
        {/* {dataPatient?.trangThaiKyBaoMat == 2 ? (
          <Row justify={"center"}>
            <Document
              noData={"không có data"}
              loading={<Spin />}
              onLoadSuccess={onLoadPageDocument}
              // onLoadError={(error) => {
              //   Notification("error", "Đã xảy ra lỗi khi tải file pdf");
              // }}
              file={(filePdf || file) as Blob}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              ))}
            </Document>
          </Row>
        ) : (
          <Row style={{ fontWeight: "bold" }} justify={"center"}>
            Bệnh nhân chưa có thông phiếu bảo mật
          </Row>
        )} */}
        <div className="print-sign" style={{ maxWidth: 900, margin: "auto" }}>
          <ContentSignSecure
            thongTinBN={{
              ...dataPatient,
              ngaySinh: convertDateStringToDateTimezone_7Dayjs(
                dataPatient.ngaySinh,
                FORMAT_TIME.dayFull2
              ),
              gioiTinh: renderGender(dataPatient.gioiTinh),
              khamLuc: convertDateStringToDateTimezone_7Dayjs(
                dataPatient.ngayNhapVien,
                FORMAT_TIME.dayFull2
              ),
            }}
            printRef={printRef}
            fileImg={fileImg}
          />
        </div>

        <Row justify={"space-between"} style={{ marginTop: "8px" }}>
          <Col span={18}>
            <Row justify={"start"} gutter={8}>
              {/* <Col>
                <ReactToPrint
                  trigger={() => {
                    return (
                      <Button icon={<Icons.printer />} onClick={onPrint}>
                        In biên bản mới
                      </Button>
                    );
                  }}
                  content={() => NewPrintRef.current}
                  bodyClass="print-sign"
                  pageStyle="@page { padding: 30px 0 }"
                />
              </Col> */}

              <Col>
                <Upload
                  customRequest={customRequest}
                  accept=".pdf"
                  multiple
                  showUploadList={false}
                >
                  <Tooltip title="Tải file lên(tối đa 3Mb)">
                    <Button
                      type="primary"
                      className="btn-sub"
                      icon={<UploadOutlined />}
                    >
                      Tải file
                    </Button>
                  </Tooltip>
                </Upload>
              </Col>
              <Col>
                <Button
                  type="default"
                  icon={<Icons.eye />}
                  onClick={handleOnView}
                  // disabled={dataPatient?.trangThaiKyBaoMat !== 2 ? true : false}
                >
                  Xem biên bản đã ký
                </Button>
              </Col>
              <Col>
                <Button
                  type="default"
                  icon={<Icons.eye />}
                  onClick={onShowModalSignSecure}
                >
                  Ký lại
                </Button>
              </Col>
              <Col>
                <ReactToPrint
                  trigger={() => {
                    return (
                      <Button onClick={onPrint} icon={<Icons.printer />}>
                        In
                      </Button>
                    );
                  }}
                  content={() => printRef.current}
                  bodyClass="print-sign"
                  pageStyle="@page { padding: 30px 0 }"
                />
              </Col>
            </Row>
          </Col>

          <Col span={6}>
            <Row justify={"end"} style={{ gap: "4px" }}>
              <Button danger onClick={closeModal}>
                HỦY
              </Button>
              {/* <Button type="primary" onClick={closeModal}>
                  Lưu
                </Button> */}
            </Row>
          </Col>
        </Row>
        {/* <div style={{ display: "none" }}>
          <Row ref={printRef} justify={"center"}>
            <Document
              className="pdf-view"
              noData={"không có data"}
              loading={<Spin />}
              onLoadSuccess={onLoadPageDocument}
              // onLoadError={(error) => {
              //   Notification("error", "Đã xảy ra lỗi khi tải file pdf");
              // }}
              file={(filePdf || file) as Blob}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              ))}
            </Document>
          </Row>
        </div> */}

        {/* <NewSignSecure ref={NewPrintRef} thongTinBN={dataPatient} /> */}

        <ModalCustom
          ref={modalViewer}
          width={900}
          title="Thông tin phiếu bảo mật pdf"
        >
          <div className="modal-view-pdf">
            <Document
              className="pdf-view"
              noData={"không có data"}
              loading={<Spin />}
              onLoadSuccess={onLoadPageDocument}
              // onLoadError={(error) => {
              //   Notification("error", "Đã xảy ra lỗi khi tải file pdf");
              // }}
              file={file as Blob}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              ))}
            </Document>
          </div>
        </ModalCustom>
      </Space>
    </Spin>
  );
};

export default SignedSecure;
